import { SideModal } from "@/components/base/SideModal"
import Account from "./Account"
import Credentials from "./Credentials"

function Settings() {
  const content = {
    members: <div>Members Settings Content</div>,
    account: <Account />,
    credentials: <Credentials />,
  }

  return (
    <SideModal
      title="Settings"
      baseHash="settings"
      items={[
        // {
        //   label: "Account",
        //   to: "account",
        //   icon: (
        //     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        //       <path
        //         d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20"
        //         stroke="currentColor"
        //         strokeWidth="2"
        //         strokeLinecap="round"
        //         strokeLinejoin="round"
        //       />
        //       <circle cx="12" cy="7.5" r="3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        //     </svg>
        //   ),
        // },
        // {
        //   label: "Members",
        //   to: "members",
        //   icon: (
        //     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        //       <path
        //         d="M16.5 20V17.9704C16.5 16.7281 15.9407 15.5099 14.8103 14.9946C13.4315 14.3661 11.7779 14 10 14C8.22212 14 6.5685 14.3661 5.18968 14.9946C4.05927 15.5099 3.5 16.7281 3.5 17.9704V20"
        //         stroke="currentColor"
        //         strokeWidth="2"
        //         strokeLinecap="round"
        //         strokeLinejoin="round"
        //       />
        //       <path
        //         d="M20.5 20.001V17.9713C20.5 16.729 19.9407 15.5109 18.8103 14.9956C18.5497 14.8768 18.2792 14.7673 18 14.668"
        //         stroke="currentColor"
        //         strokeWidth="2"
        //         strokeLinecap="round"
        //         strokeLinejoin="round"
        //       />
        //       <circle cx="10" cy="7.5" r="3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        //       <path
        //         d="M15 4.14453C16.4457 4.57481 17.5 5.91408 17.5 7.49959C17.5 9.0851 16.4457 10.4244 15 10.8547"
        //         stroke="currentColor"
        //         strokeWidth="2"
        //         strokeLinecap="round"
        //         strokeLinejoin="round"
        //       />
        //     </svg>
        //   ),
        // },
        {
          label: "Credentials",
          to: "credentials",
          icon: <IconHugeiconsFingerAccess className="" />,
        },
      ]}
      content={content}
      defaultSection="credentials"
    />
    // <SideLayout
    //   title="Settings"
    //   items={[
    //     {
    //       label: "Account",
    //       to: "/settings/account",
    //     },
    //     {
    //       label: "Members",
    //       to: "/settings/members",
    //     },
    //   ]}
    // >
    //   <Routes>
    //     <Route path="account/:id?" element={<Account />} />
    //     <Route path="members/:id?" element={<Members />} />
    //     <Route index path="/*" element={<Navigate replace to="/settings/account" />} />
    //   </Routes>
    // </SideLayout>
  )
}

export default Settings
